import React, { useEffect } from 'react';
import { VideoCarousel } from './VideoCarousel';

const videos = [
  {
    id: 1,
    url: "https://player.vimeo.com/video/1084687516?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 2,
    url: "https://player.vimeo.com/video/1034199235?badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 3,
    url: "https://player.vimeo.com/video/1034199247?h=c2c7d469c8&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 4,
    url: "https://player.vimeo.com/video/1034199275?h=95c09acb01&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 5,
    url: "https://player.vimeo.com/video/1034199216?h=856d55fee0&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 6,
    url: "https://player.vimeo.com/video/1034199260?h=b2deb1a342&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 7,
    url: "https://player.vimeo.com/video/1034199200?h=65ca4e6b32&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 8,
    url: "https://player.vimeo.com/video/1034199182?h=259ea18b6e&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 9,
    url: "https://player.vimeo.com/video/1034199167?h=0cf7372c9c&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 10,
    url: "https://player.vimeo.com/video/1034199137?h=2548f3d2b2&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 11,
    url: "https://player.vimeo.com/video/1034196353?h=121ffca531&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  },
  {
    id: 12,
    url: "https://player.vimeo.com/video/1034194809?h=742beaf582&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    aspectRatio: "56.25%"
  }
];

export const VideoGallery = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="max-w-7xl mx-auto">
      <VideoCarousel videos={videos} />
    </div>
  );
};